import React from "react";
import { useIntl } from "react-intl";
import NoData from "./NoData";

const NoEposterData = ({ children, data }) => {
  const intl = useIntl();

  return (
    <NoData
      data={data}
      message={intl.formatMessage({
        id: "Shared.NoEposterData.NoEposter",
        defaultMessage: "There are no e-Posters. Please check later for new contents..."
      })}
    >
      {children}
    </NoData>
  );
};

export default NoEposterData;
